/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const DELETE_BATCH_LOADING = "DELETE_BATCH_LOADING";
export const DELETE_BATCH_REBATE_PROGRAM_DATA =
  "DELETE_BATCH_REBATE_PROGRAM_DATA";
export const DELETE_BATCH_FILTER = "DELETE_BATCH_FILTER";
export const DELETE_BATCH_USERDEFAULT = "DELETE_BATCH_USERDEFAULT";
export const DELETE_BATCH_RESET_STORE = "DELETE_BATCH_RESET_STORE";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
